import { Pipe } from '@angular/core';
import { BillingPeriod } from '@benefitsui/app/api/benefits-clients';
import { DateTimeUtilities } from '@benefitsui/app/shared/utilities/dateTimeUtilities';

@Pipe({
  name: 'billingPeriodToStringPipe',
  standalone: false
})

export class BillingPeriodToStringPipe {
  transform(billingPeriod: BillingPeriod | undefined): string {
    const billingPeriodString = DateTimeUtilities.billingPeriodToString(billingPeriod);
    return billingPeriodString;
  }
}
